/*
 * @author Oleksandr Papka <papkaos>
 */
angular.module('gccs-ui').directive('gccsSelectFilteredGrouped', () => {
  return {
    restrict: 'A',
    controller: 'SelectFilteredController',
    controllerAs: '$ctrl',
    template: require('./template.pug'),
    bindToController: true,
    scope: {
      selectClassName: '@',
      withoutDefaultClass: '@',
      name: '@',
      filterPlaceholder: '@',
      searchInputClassName: '@',
      withIcons: '<',
      selectedItem: '<',
      selectListItems: '<',
      selectedListItems: '<',
      withoutRightAlign: '<',
      isGroupedSelect: '<',
      onSelect: '&'
    }
  };
});